var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMydocument(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.714,
    height: 20,
    viewBox: "0 0 15.714 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Union_33",
    "data-name": "Union 33",
    fill: "#002a57",
    d: "M.715,20A.713.713,0,0,1,0,19.285V.715A.713.713,0,0,1,.715,0H11.428a.715.715,0,0,1,.551.257L15.55,4.543A.709.709,0,0,1,15.714,5V19.285A.713.713,0,0,1,15,20Zm.714-1.428H14.286V5.714H11.428A.713.713,0,0,1,10.715,5V1.428H1.428ZM12.143,4.286h1.328l-1.328-1.6ZM4.714,15.714a.714.714,0,0,1,0-1.428H9a.714.714,0,0,1,0,1.428Zm0-3a.714.714,0,1,1,0-1.428H11a.714.714,0,0,1,0,1.428Zm0-3a.715.715,0,0,1,0-1.429H11a.715.715,0,0,1,0,1.429Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMydocument);
export default __webpack_public_path__ + "static/media/Mydocument.d3e277fb190f44d3e27446e322dd8a5b.svg";
export { ForwardRef as ReactComponent };